import { CanMatchFn, Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { APP_PATHS } from '../config/app-paths';
import { ApplicationContextService } from '../services/application-context.service';

export const AuthGuard: CanMatchFn = (route, segments): Observable<boolean> => {
  const authService = inject(AuthService);
  const applicationContextService = inject(ApplicationContextService);
  const router = inject(Router);
  return authService.checkAndHandleSession$().pipe(
    tap((hasSession: boolean) => {
      // Jezeli posiada sesje i context administratora to brak dostepu do route z kontekstu beneficjenta i organizacji
      if (hasSession && applicationContextService.isAdminContext()) {
        router.navigate([APP_PATHS.admin.root]);
        return false;
      } else if (hasSession) {
        return true;
      } else {
        router.navigate([APP_PATHS.auth.root, APP_PATHS.auth.loginMethod]);
        return false;
      }
    }),
  );
};
